import React from 'react';
import SEO from '../../components/ui/SEO';
import ServicePageTemplate from '../../components/ui/ServicePageTemplate';
import { servicePages } from '../../data/services';
export default function Specialist() {
  return <main className="min-h-screen bg-white" data-id="element-1143" data-mp="20lz7dtpm7ns9">
      <SEO title="Immigration, Employment and Family Psychiatric Reports" description="Independent psychiatric reports for immigration and asylum appeals, Employment Tribunal, professional and family proceedings. Request a fee quote." path="/services/specialist" keywords={['immigration psychiatric report', 'psychiatric report for Employment Tribunal', 'family court psychiatric assessment', 'asylum psychiatric report']} imageAlt="Psychiatric reports for immigration, employment and family proceedings" schema={{
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Immigration, Employment and Family Psychiatric Reports',
      serviceType: 'Court and tribunal psychiatric reporting',
      url: 'https://medicolegal-psychiatry.co.uk/services/specialist',
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'England and Wales'
      },
      provider: {
        '@type': 'Organization',
        name: 'Medicolegal Psychiatry',
        url: 'https://medicolegal-psychiatry.co.uk'
      },
      audience: {
        '@type': 'Audience',
        name: 'Legal professionals'
      },
      description: 'Psychiatric evidence for immigration, asylum and human rights appeals, Employment Tribunal and professional regulatory proceedings, and family proceedings.'
    }} data-id="element-1144" data-mp="20ko5y0jn6s4b" />
      <ServicePageTemplate content={servicePages.specialist} data-id="element-1145" data-mp="3oruyuh6oyl3d" />
    </main>;
}